import type { PublicUser } from '@/types/user.types';
import { useCurrentUser } from '@/hooks/useCurrentUser.hook';

interface UseDashboardPageResult {
  user: PublicUser | undefined;
  isLoading: boolean;
}

export const useDashboardPage = (): UseDashboardPageResult => {
  const { user, isLoading } = useCurrentUser();
  return { user, isLoading };
};
